import axios from 'axios'
import { getSessionToken, getCsrfToken } from '@futures-platform/connectors/session'
import statisticsApi from '@futures-platform/connectors/statistics-api'
// import contentServiceAPIs from '@futures-platform/connectors/content-service-api'
import newsFeedApi  from '@futures-platform/connectors/news-feed-api'

const SEARCH_API_URL = process.env.REACT_APP_SEARCH_API_URL
const RADAR_API_URL = process.env.REACT_APP_RADAR_DATA_API_URL
const CONTENTSERVICE_API_URL = process.env.REACT_APP_CONTENTSERVICE_API_URL
const REACT_APP_NEWS_FEED_API_URL = process.env.REACT_APP_NEWS_FEED_API_URL
/*
 Fields in document: short_name,image_url,archived,uuid,ingress_body,original_id,language,
 related_phenomena,title,group,state,visibility,video_url,media_text,description,body,feed_tag,
 media_body_text
 */

 async function httpRequest(baseUrl, method, path, payload = null) {
return axios({
    method,
    url: `${baseUrl}/${path}`,
    headers: {
        'X-CSRF-Token': getCsrfToken(),
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getSessionToken()}`
    },
    withCredentials: true,
    data: payload || null
})
}

 async function httpGetRequest(baseUrl,path, payload = null) {
  return axios({
      method: 'get',
      url: `${baseUrl}/${path}`,
      headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getSessionToken()}`
      },
      withCredentials: true,
      data: payload || null
  })
}


async function httpPostRequest(type, payload = null) {
    return axios({
        method: 'post',
        url: `${SEARCH_API_URL}/${type}`,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getSessionToken()}`
        },
        data: payload
    }).then(res => res.data)
}

export async function getRadarData(rid) {
  return httpGetRequest(RADAR_API_URL, rid)
}

export async function getContentCardData(gid, phenId) {
  return await httpRequest(CONTENTSERVICE_API_URL, 'GET', `doc/${gid}/phenomenon/${phenId}?newsfeeds=true`)
}

export async function getNewsFeedsDataByNewsFeedsIdsAndGid(payload) {
  return await httpRequest(SEARCH_API_URL, 'POST', `news-item`, payload)
}

// eslint-disable-next-line max-params
export async function getPhenomenonNewsByPhenId(news_feed_uuids, gid=[0], language, size = 10) {
  return httpPostRequest('news-item', {
    news_feed_uuids: news_feed_uuids,
    groups: gid,
    language,
    size
  }).then(({result}) => {
    if(result?.length > 10) {
      return result?.slice(0, 10)
    } 
    return result
  })
}

// eslint-disable-next-line max-params
export async function getPhenomena({ phenomena = [], query, groups = [0], page = 0, size = 10, language = null, enhanced = 1, tags = [], types = [], time_min = null, time_max = null, include_archived = false }) {
    if (!getSessionToken()) {
      return { result: [], page: { totalPages: 0 } }
    }
    return httpPostRequest('phenomenon', {
      phenomena,
      query,
      groups,
      page,
      size,
      language,
      enhanced,
      include_archived,
      // TODO: Implement passing properties in this structure
      tags: tags.length > 0 ? { 'fp:docs/props/has': tags } : {},
      types,
      time_min,
      time_max
    }).then(({result, ...rest}) => ({
      // TODO: Replace group in using function with groups property
      // TODO: Start to use separate properties for tags
      result: result.map(({ groups, ...doc }) => ({
        groups,
        group: groups.length > 0 && groups[1],
        ...doc,
        tags: Object.keys(doc).reduce((tags, key) => /^tags_/.test(key) ? [...tags, ...doc[key]] : tags, [])
      })),
      ...rest
    }))
}

export async function getPhenomenaStatistic (id) {
  if (!getSessionToken()) {
    return null
  }
  return statisticsApi.getPhenomenaStatistics(id);
}

export async function getNewsFeedData(groupId, phenomenonUuid) {
  return newsFeedApi.getNewsFeeds(groupId, phenomenonUuid);
}